<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Semanal Infantil
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  !gestaoDeAula.is_polivalencia == 1
                    ? gestaoDeAula.disciplina.descricao
                    : gestaoDeAula.disciplina
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>

          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>

      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.mes_id" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.mesesPlanoSemanal"
                :key="item.id"
                @click="() => loadData(item.id)"
              >
                <v-badge v-if="form.mes_id === item.id" color="success">
                  {{ item.descricao }}
                </v-badge>
                <div v-else>{{ item.descricao }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <v-tabs-items v-model="form.mes_id">
      <v-tab-item v-for="item in $constants.mesesPlanoSemanal" :key="item.id">
        <v-card flat>
          <v-card-text>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form
                @submit.prevent="handleSubmit(createOrUpdate)"
                v-if="loadPlano"
                :disabled="submittingForm"
              >
                <v-row>
                  <v-col cols="6" md="6">
                    <e-label>ESCOLHA A SEMANA</e-label>
                    <e-autocomplete
                      :items="$constants.semanas"
                      :return-object="false"
                      item-text="descricao"
                      item-value="id"
                      v-model="form.semana_id"
                      label="Escolha a Semana"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="6" md="6">
                    <e-label>DIAS DA SEMANA</e-label>
                    <e-autocomplete
                      :items="$constants.dias_semanas"
                      :return-object="false"
                      item-text="descricao"
                      item-value="id"
                      v-model="form.dia_semana_id"
                      label="Escolha o dia da semana"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="6" md="6">
                    <e-label>Anexar plano</e-label>
                    <div class="dropboxStyles">
                      <v-row>
                        <v-col cols="6">
                          <v-file-input
                            v-model="form.file"
                            accept="application/pdf"
                            dense
                            solo
                            label="Plano semanal"
                            prepend-icon="mdi-file"
                            chip-color="red"
                            @change="onFileSelected($event)"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="3" class="text-right" v-if="form.path">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="downloadPlanoSemanal(item)"
                                class="ml-2"
                                color="red lighten-5"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="red lighten-1" small>fa fa-file-pdf</v-icon>
                                <span class="ml-2">Baixar arquivo</span>
                              </v-btn>
                            </template>
                            <span>Baixar arquivo</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" v-if="form.path">
                          <v-alert dense color="green" icon="mdi-check-circle" text border="left">
                            Enviado: {{ form.path }}
                          </v-alert>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <ValidationProvider
                      name="Habilidades da BNCC"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <e-label>HABILIDADES DA BNCC</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.habilidades_bncc"
                        :error-messages="errors"
                        @input="form.habilidades_bncc = form.habilidades_bncc.slice(0, 300)"
                      />
                    </ValidationProvider>

                    <ValidationProvider name="Conteúdo" rules="required" v-slot="{ errors }">
                      <e-label>CONTEÚDO</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.conteudo"
                        :error-messages="errors"
                        @input="form.conteudo = form.conteudo.slice(0, 300)"
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <label for="">DIREITOS DE APRENDIZAGEM</label>
                    <v-card class="pa-md-4">
                      <div>
                        <ValidationProvider
                          name="Direitos de Aprendizagem"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="direitosDeAprendizagemSelecionadas"
                            :items="$constants.direitos_aprendizagem"
                            attach
                            chips
                            label="Marque uma ou mais opções"
                            multiple
                            :error-messages="errors"
                            item-text="descricao"
                            item-value="id"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <label for="">CAMPOS DE EXPERIÊNCIAS</label>
                    <v-card class="pa-md-4">
                      <div>
                        <ValidationProvider
                          name="Campos de Experiências"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="campoDeExperienciaSelecionadas"
                            :items="$constants.campos_experiencias"
                            attach
                            chips
                            label="Marque uma ou mais opções"
                            multiple
                            :error-messages="errors"
                            item-text="descricao"
                            item-value="id"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <label for="">ROTINA</label>
                    <v-card class="pa-md-4">
                      <div class="mb-4">
                        <ValidationProvider
                          name="Acolhida / Roda de Conversa"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label>ACOLHIDA / RODA DE CONVERSA</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.acolhida_roda_conversa"
                            :error-messages="errors"
                            @input="
                              form.acolhida_roda_conversa = form.acolhida_roda_conversa.slice(
                                0,
                                300
                              )
                            "
                          />
                        </ValidationProvider>
                      </div>

                      <div class="mb-4">
                        <ValidationProvider
                          name="Construção e Exploração do Conhecimento"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label>CONSTRUÇÃO E EXPLORAÇÃO DO CONHECIMENTO</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.construcao_exploracao_conhecimento"
                            :error-messages="errors"
                            @input="
                              form.construcao_exploracao_conhecimento =
                                form.construcao_exploracao_conhecimento.slice(0, 300)
                            "
                          />
                        </ValidationProvider>
                      </div>

                      <div class="mb-4">
                        <e-label>HIGIENE E ALIMENTAÇÃO</e-label>
                        <v-textarea
                          solo
                          dense
                          counter="300"
                          maxlength="300"
                          v-model="form.higiene_alimentacao"
                          :error-messages="errors"
                          @input="form.higiene_alimentacao = form.higiene_alimentacao.slice(0, 300)"
                        />
                      </div>

                      <div class="mb-4">
                        <ValidationProvider
                          name="Atividades Diversificadas"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label>ATIVIDADES DIVERSIFICADAS</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.atividades_diversificadas"
                            :error-messages="errors"
                            @input="
                              form.atividades_diversificadas = form.atividades_diversificadas.slice(
                                0,
                                300
                              )
                            "
                          />
                        </ValidationProvider>
                      </div>

                      <div class="mb-4">
                        <ValidationProvider
                          name="Roda de Histórias"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label>RODA DE HISTÓRIAS</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.roda_historias"
                            :error-messages="errors"
                            @input="form.roda_historias = form.roda_historias.slice(0, 300)"
                          />
                        </ValidationProvider>
                      </div>

                      <div class="mb-4">
                        <ValidationProvider
                          name="Tempo de Brincar"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label>TEMPO DE BRINCAR</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.tempo_brincar"
                            :error-messages="errors"
                            @input="form.tempo_brincar = form.tempo_brincar.slice(0, 300)"
                          />
                        </ValidationProvider>
                      </div>

                      <div class="mb-4">
                        <ValidationProvider name="Saída" rules="required" v-slot="{ errors }">
                          <e-label>SAÍDA</e-label>
                          <v-textarea
                            solo
                            dense
                            counter="300"
                            maxlength="300"
                            v-model="form.saida"
                            :error-messages="errors"
                            @input="form.saida = form.saida.slice(0, 300)"
                          />
                        </ValidationProvider>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <label for="">AGENDA</label>
                    <ValidationProvider name="Agenda" rules="required" v-slot="{ errors }">
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="rotinaOutros"
                        :error-messages="errors"
                        @input="rotinaOutros = rotinaOutros.slice(0, 300)"
                      />
                    </ValidationProvider>
                  </v-col>
                  <!-- <v-col>
                    <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                      <e-label>METODOLOGIA</e-label>
                      <v-textarea
                        solo
                        dense
                        counter="300"
                        maxlength="300"
                        v-model="form.metodologia"
                        :error-messages="errors"
                        @input="form.metodologia = form.metodologia.slice(0, 300)"
                      />
                    </ValidationProvider>
                  </v-col> -->
                </v-row>
                <v-col cols="12">
                  <v-row>
                    <v-btn
                      color="primary"
                      :disabled="submittingForm"
                      :loading="submittingForm"
                      type="submit"
                    >
                      Enviar Dados
                    </v-btn>
                  </v-row>
                </v-col>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      habilidade: null,
      experiencia_: null,
      modalDeletarObjetivo: false,
      mensagem: "",
      carregandoHabilidades: false,
      showMessage: false,
      dialog: false,
      search: "",
      submittingForm: false,
      form: {
        mes_id: 0,
        semana_id: 0,
        dia_semana_id: null,
        path: "",
        file: null,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      loadPlano: true,
      semanaSelecionada: null,
      direitosDeAprendizagemSelecionadas: [],
      campoDeExperienciaSelecionadas: [],
      rotinasSelecionadas: [],
      rotinaOutros: "",
    };
  },
  watch: {
    "form.semana_id": function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.loadData();
      }
    },
    "form.mes_id": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadData(newVal);
      }
    },
    "form.dia_semana_id": function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.loadData();
      }
    },
  },
  methods: {
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      if (
        this.form.semana_id === null ||
        this.form.semana_id === undefined ||
        this.form.semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione uma semana.");
        return;
      }

      if (
        this.form.dia_semana_id === null ||
        this.form.dia_semana_id === undefined ||
        this.form.dia_semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione um dia da semana.");
        return;
      }

      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { mes_id, semana_id, dia_semana_id } = this.form;

        this.form.mes_id = mes_id;
        this.form.semana_id = semana_id;
        this.form.dia_semana_id = dia_semana_id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        this.form.direitosDeAprendizagemSelecionadas = this.direitosDeAprendizagemSelecionadas;
        this.form.campoDeExperienciaSelecionadas = this.campoDeExperienciaSelecionadas;
        this.form.rotinaOutros = this.rotinaOutros;

        await this.$services.planosSemanaisInfantilService.createOrUpdate(this.form);
        this.$toast.success("Plano semanal salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData(id) {
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);

      if (id) this.form.mes_id = id;

      try {
        this.$loaderService.open("Carregando dados...");
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosSemanaisInfantilService.planoSemanal(
          gestaoDeAulaId,
          this.form.mes_id,
          this.form.semana_id,
          this.form.dia_semana_id,
          this.disciplinaId
        );

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplinaId;
          });

          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        if (response && response.plano) {
          this.form = { ...response.plano };

          this.direitosDeAprendizagemSelecionadas =
            typeof response.plano.direitosDeAprendizagemSelecionadas === "string"
              ? JSON.parse(response.plano.direitosDeAprendizagemSelecionadas)
              : response.plano.direitosDeAprendizagemSelecionadas || [];

          this.campoDeExperienciaSelecionadas =
            typeof response.plano.campoDeExperienciaSelecionadas === "string"
              ? JSON.parse(response.plano.campoDeExperienciaSelecionadas)
              : response.plano.campoDeExperienciaSelecionadas || [];

          this.rotinasSelecionadas =
            typeof response.plano.rotinasSelecionadas === "string"
              ? JSON.parse(response.plano.rotinasSelecionadas)
              : response.plano.rotinasSelecionadas || [];

          this.rotinaOutros = response.plano.rotinaOutros || "";
        } else {
          this.form = {
            mes_id: this.form.mes_id,
            semana_id: this.form.semana_id,
            dia_semana_id: this.form.dia_semana_id,
            habilidades_bncc: "",
            conteudo: "",
            metodologia: "",
          };

          this.direitosDeAprendizagemSelecionadas = [];
          this.campoDeExperienciaSelecionadas = [];
          this.rotinasSelecionadas = [];
          this.rotinaOutros = "";
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async onFileSelected(file) {
      if (!file) return;

      this.isUploading = true;

      const { gestaoDeAulaId } = this.$route.params;
      const { disciplinaId } = this.$route.params;
      const { mes_id, semana_id, dia_semana_id } = this.form;
      if (
        this.form.semana_id === null ||
        this.form.semana_id === undefined ||
        this.form.semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione uma semana.");
        return;
      }

      if (
        this.form.dia_semana_id === null ||
        this.form.dia_semana_id === undefined ||
        this.form.dia_semana_id === ""
      ) {
        this.$toast.danger("Por favor, selecione um dia da semana.");
        return;
      }
      try {
        const response = await this.$services.planosSemanaisInfantilService.planoSemanalPDF(
          gestaoDeAulaId,
          disciplinaId,
          mes_id,
          semana_id,
          dia_semana_id,
          file
        );

        this.$set(this.form, "path", response.path);
      } catch (error) {
        this.$toast.danger(error.error || "Erro ao enviar o arquivo.");
        this.$handleError(error);
      } finally {
        this.isUploading = false;
      }
    },

    async downloadPlanoSemanal(semestre) {
      const { gestaoDeAulaId } = this.$route.params;
      const { mes_id, semana_id, dia_semana_id } = this.form;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);

      try {
        await this.$services.planosSemanaisInfantilService.downloadPlanoSemanal(
          gestaoDeAulaId,
          this.disciplinaId,
          mes_id,
          semana_id,
          dia_semana_id
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
  },
};
</script>

<style></style>
